import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { transientOptions } from "shared/lib/styles";

import {
  StyledYouTube,
  VideoContainer,
} from "scmp-app/components/scmp-youtube-video/scmp-youtube-video-player/styles";

import { SCMPYouTubeVideoFooter } from "./scmp-youtube-video-footer";
import { SCMPYoutubeVideoPreview } from "./scmp-youtube-video-preview";

type StyledSCMPYouTubeVideoFooterProps = {
  $orientation: "landscape" | "portrait";
};

export const StyledSCMPYouTubeVideoFooter = styled(SCMPYouTubeVideoFooter, {
  ...transientOptions,
})<StyledSCMPYouTubeVideoFooterProps>`
  ${props => {
    if (props.$orientation === "portrait") {
      return css`
        &&&& {
          inline-size: var(--portrait-inline-size);
          margin-inline: auto;
        }
      `;
    }
    switch (props.variant) {
      case "default":
        return css`
          display: flex;
        `;
    }
  }}
`;

export const StyledSCMPYoutubeVideoPreview = styled(SCMPYoutubeVideoPreview)`
  position: absolute;
  inset: 0;
  z-index: 1;
`;

type SCMPYoutubeVideoContainerProps = {
  $orientation: "landscape" | "portrait";
};

export const PlayerContainer = styled.div<SCMPYoutubeVideoContainerProps>`
  position: relative;

  inline-size: 100%;
  block-size: 100%;

  ${StyledSCMPYoutubeVideoPreview} {
    margin-inline: auto;
  }

  ${props =>
    props.$orientation === "portrait"
      ? css`
          aspect-ratio: 9 / 16;

          max-inline-size: var(--portrait-inline-size);
          margin-inline: auto;

          ${VideoContainer} {
            aspect-ratio: 9 / 16;
          }
          ${StyledYouTube} {
            iframe {
              aspect-ratio: 9 / 16;
            }
          }
        `
      : css`
          aspect-ratio: 16 / 9;

          ${VideoContainer} {
            aspect-ratio: 16 / 9;
          }
          ${StyledYouTube} {
            iframe {
              aspect-ratio: 16 / 9;
            }
          }
        `}
`;

export const Container = styled.div``;
